export enum OrganiserActionTypes {
    LIST_REQUEST = '@@Organiser/LIST_REQUEST',
    LIST_SUCCESS = '@@Organiser/LIST_SUCCESS',
    LIST_ERROR = '@@Organiser/LIST_ERROR',
    LIST_CLEAR = '@@Organiser/LIST_CLEAR',

    SELECT = '@@Organiser/SELECT',
    SELECTED = '@@Organiser/SELECTED',
    CLEAR_SELECTED = '@@Organiser/CLEAR_SELECTED',
    
    CREATE_REQUEST = '@@Organiser/CREATE_REQUEST',
    CREATE_SUCCESS = '@@Organiser/CREATE_SUCCESS',
    CREATE_ERROR = '@@Organiser/CREATE_ERROR',
    
    // READ_REQUEST = '@@Organiser/READ_REQUEST',
    // READ_SUCCESS = '@@Organiser/READ_SUCCESS',
    // READ_ERROR = '@@Organiser/READ_ERROR',

    UPDATE_REQUEST = '@@Organiser/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@Organiser/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@Organiser/UPDATE_ERROR',
    
    DELETE_REQUEST = '@@Organiser/DELETE_REQUEST',
    DELETE_SUCCESS = '@@Organiser/DELETE_SUCCESS',
    DELETE_ERROR = '@@Organiser/DELETE_ERROR'
}

export interface OrganiserUIState {
    readonly loading: boolean
    readonly searchParams?: any
    readonly processing: boolean // For CRUD Operation
    readonly processState: number
    readonly selected?: string
    readonly errors?: string []
    readonly isConflict : boolean
    readonly totDoc?: number
}
